import View from './view';
import ErrorPopup from '../error';
import Log from '../../util/log';
import WafCaptchaPopup from '../waf-captcha';

export default class Presenter {
  constructor(model, config, removeLoader) {
    this.model = model;
    this.config = config;
    this.removeLoader = removeLoader;
    this.hashSetup = false;
  }

  onAttach() {
    if (this.config && !this.hashSetup) {
      this.setup();
      this.hashSetup = true;
    }
  }

  update(hash, config) {
    this.model.hash = hash;
    this.model.config = config;
    this.config = config;
    if (this.config && !this.hashSetup) {
      this.setup();
      this.hashSetup = true;
    }
  }

  onLogin(notificationType) {
    this.model.values = {
      notificationType,
      index: View.Page.link,
    };
  }

  onContinueClick() {
    this.model.showMobileOnly = false;
  }

  setup() {
    const {
      app_id: appId,
      vlabs_api_url: vlabsApiUrl,
      vlabs_aws_waf_threat_detection_url: awsWafThreatDetectionUrl,
      vlabs_aws_waf_captcha_url: awsWafCaptchaUrl,
      vlabs_aws_waf_captcha_api: awsWafCaptchaApi,
      aws_waf_threat_detection_url: awsWafThreatDetectionUrlBackCompat,
      environment,
      version,
      key,
      domain,
      ga_tracking_id: ga,
      campaign,
      debug,
      error: errorConfig,
      facebook_app_id: facebook,
      google_app_id: google,
      samsung_app_id: samsung,
      samsung_alias_id: samsungAlias,
      outside_app_id: outside,
      session_bypass: sessionBypass,
      signup_bypass: signupBypass,
      platform_api_url: platformApiUrl,
      request_applet: requestAppletConfig,
    } = this.config;

    const { hostname } = window.location;
    if (domain && hostname !== domain) {
      const url = new URL(
        `https://${domain}${window.location.pathname}${window.location.hash}${window.location.search}`
      );
      window.location.replace(url);
      return;
    }

    const { delay: errorDelay, redirect_on_load: redirectOnLoadError } = errorConfig;

    // allow testing of error screen, this should be disabled for prod
    if (debug?.show_error?.code) {
      ErrorPopup.show(debug.show_error.code, () => {});
    }

    if (requestAppletConfig) {
      const domainParts = window.location.hostname.split('.');
      domainParts.splice(1, 0, 'ra');
      const requestAppletUrl = `https://${domainParts.join('.')}`;
      requestAppletConfig.url = requestAppletUrl;
      requestAppletConfig.onready = (error) => {
        if (error) {
          ErrorPopup.show({ code: 'request_applet_init_error' }, () => {
            window.location.reload();
          });
        }
      };
    }

    VlabsUser.init({
      key,
      config: {
        app_id: appId,
        vlabs_api_url: vlabsApiUrl,
        request_applet: requestAppletConfig?.enabled ? requestAppletConfig : undefined,
        platform_api_url: platformApiUrl,
        aws_waf_threat_detection_url:
          awsWafThreatDetectionUrl ?? awsWafThreatDetectionUrlBackCompat,
        aws_waf_captcha:
          (awsWafCaptchaUrl &&
            awsWafCaptchaApi && {
              url: awsWafCaptchaUrl,
              api: awsWafCaptchaApi,
              onrequest: () => WafCaptchaPopup.show(awsWafCaptchaApi),
            }) ||
          undefined,
        environment,
        version,
        ga,
        campaign,
        facebook_app: facebook,
        google_app: google,
        samsung_app: samsung,
        samsung_alias: samsungAlias,
        outside_app: outside,
        session_bypass: sessionBypass,
        signup_bypass: signupBypass,
      },
    });

    VlabsUser.load(
      () => {
        const { email, phone } = VlabsUser.query || {};
        this.model.initialToken = email || phone;
        this.removeLoader?.();
        this.removeLoader = null;
      },
      () => {
        this.model.index = View.Page.link;
        this.removeLoader?.();
        this.removeLoader = null;
      },
      (error) => {
        ErrorPopup.show(error, () => {}, redirectOnLoadError && errorDelay);
        this.removeLoader?.();
        this.removeLoader = null;
        Log.error(error);
      }
    );
  }
}
